import { FeatureFlags } from '@mobi/settings'
import { useFeature } from '@core/Utils/hooks'

export function useKambiMaintenanceFeature(): false | string {
  const isMaintenanceActive = useFeature(FeatureFlags.KAMBI_MAINTENANCE.key) as { endTime?: string }
  return isMaintenanceActive?.endTime || false
}
